'use client';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useEmailConfirm } from '~features/emailConfirm/hooks/useEmailConfirm';
import { lsKeys, saveToStorage } from '~features/storage';
import { useUserId } from '~hooks/useUserId';
import {
	emailConfirmActions,
	emailConfirmSelectors,
} from '~store/email-confirm';

export const useEmailConfirmModal = (): {
	isOpened: boolean;
	open: (force?: boolean) => void;
	close: () => void;
} => {
	const userId = useUserId();
	const dispatch = useDispatch();

	const opened = useSelector(emailConfirmSelectors.getIsModalOpened);

	const { confirmed, isLoading } = useEmailConfirm();
	const open = useCallback(() => {
		dispatch(emailConfirmActions.showModal());
	}, [dispatch]);

	const close = useCallback(() => {
		saveToStorage(lsKeys.HIDE_EMAIL_CONFIRM_MODAL, true);
		dispatch(emailConfirmActions.hideModal());
	}, [dispatch]);

	const isOpened = !!userId && opened && !isLoading && !confirmed;

	useEffect(() => {
		if (isOpened) {
			dispatch(emailConfirmActions.storeModalShown());
		}
	}, [dispatch, isOpened]);

	return { isOpened, open, close };
};
